import { operatorsList, operatorsString, operatorsNumber, operatorsDate, operatorsBoolean, operatorsHybrid } from 'constants/operators'
import { FilterOptionsTypesEnum } from 'enum/filterType.enum'
import { IFilterOptions } from 'interfaces/filterProps'

type TTranslations = Record<string, any>

export type TFiltersOperator = {
  label: string
  value: string
}

export const getFilterOperators = (translations: TTranslations, type = 'string') => {
  let operations = []
  const { list, tagsList, string, number, date, boolean, hybrid } = FilterOptionsTypesEnum
  translations[hybrid] = { ...translations[string], ...translations[list] }

  switch (type) {
    case list:
      operations = operatorsList
      break
    case tagsList:
      operations = operatorsList
      break
    case string:
      operations = operatorsString
      break
    case number:
      operations = operatorsNumber
      break
    case date:
      operations = operatorsDate
      break
    case boolean:
      operations = operatorsBoolean
      break
    case hybrid:
      operations = operatorsHybrid
      break
    default:
      operations = operatorsString
      break
  }

  const labelFn = (value: string) => (translations[type] ? translations[type][value] : value)
  return operations.map((value) => ({ label: labelFn(value), value })) as TFiltersOperator[]
}

export const getFilterOptionsOperators = (translations: TTranslations, filters: IFilterOptions[] = [], type = 'string') => {
  if (!filters.length) return undefined

  const { list, string, hybrid } = FilterOptionsTypesEnum
  translations[hybrid] = { ...translations[string], ...translations[list] }
  const labelFn = (label: string, value: string) => label || (translations[type] ? translations[type][value] : value)
  return filters?.map(({ label, value, mapBy }) => ({ label: labelFn(label, value), value, mapBy })).filter(({ label }) => label) as TFiltersOperator[]
}
